var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-notice-bar",
    {
      attrs: { scrollable: false, "left-icon": "volume-o" },
      scopedSlots: _vm._u([
        {
          key: "left-icon",
          fn: function() {
            return [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showHeadImg,
                    expression: "!showHeadImg"
                  }
                ],
                staticClass: "notice",
                attrs: {
                  src: require("@/assets/common/NoticeListBar.png"),
                  alt: ""
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "van-swipe",
        {
          class: ["notice-swipe"],
          attrs: { autoplay: 3000, "show-indicators": false, vertical: "" }
        },
        _vm._l(_vm.fictitiousLists, function(item, i) {
          return _c("van-swipe-item", { key: i }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showHeadImg,
                  expression: "showHeadImg"
                }
              ],
              staticClass: "notice-headbc",
              attrs: {
                src: item.imgUrl || require("@/assets/common/avator.png"),
                alt: ""
              }
            }),
            _vm._v(" " + _vm._s(item.scrollInfo) + " ")
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }